import {
  Alert,
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IconChevronLeft, IconHome } from "@tabler/icons-react";
import { FC } from "react";
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { APP_TITLE, RESPONSE_ERROR_MESSAGE } from "../../constants/dashboard";

function getErrorMessage(status: number) {
  // if (RESPONSE_ERROR_MESSAGE[status as keyof typeof RESPONSE_ERROR_MESSAGE]) {
  //   return RESPONSE_ERROR_MESSAGE[status as keyof typeof RESPONSE_ERROR_MESSAGE];
  // } else {
  //   return RESPONSE_ERROR_MESSAGE.DEFAULT;
  // }
  switch (status) {
    case 400:
      return RESPONSE_ERROR_MESSAGE[400];
    case 401:
      return RESPONSE_ERROR_MESSAGE[401];
    case 403:
      return RESPONSE_ERROR_MESSAGE[403];
    case 404:
      return RESPONSE_ERROR_MESSAGE[404];
    case 500:
      return RESPONSE_ERROR_MESSAGE[500];
    case 503:
      return RESPONSE_ERROR_MESSAGE[503];
    default:
      return RESPONSE_ERROR_MESSAGE.DEFAULT;
  }
}

const ErrorPage: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const error: any = useRouteError();
  const isRouteError = isRouteErrorResponse(error);
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="sm">
      <Stack spacing={4} mt={8} mb={3} alignItems="center">
        <Typography
          variant="h4"
          component="h1"
          sx={{
            mb: 2,
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          {APP_TITLE.ERROR_TITLE}
        </Typography>
        <Typography
          variant="h1"
          fontWeight={900}
          fontSize={isMobile ? 120 : 200}
          sx={{ color: "#dee2e6" }}
        >
          {isRouteError ? error.status : "Oops!"}
        </Typography>
        <Typography>
          {isRouteError
            ? getErrorMessage(error.status)
            : error.message || RESPONSE_ERROR_MESSAGE.DEFAULT}
        </Typography>
        {error.data?.message && (
          <Alert severity="error">{error.data.message}</Alert>
        )}
        {isRouteError && error.status === 401 ? (
          <Button variant="contained" onClick={() => navigate("/auth/login")}>
            Sign In
          </Button>
        ) : isRouteError && (error.status === 500 || error.status === 503) ? (
          <Button variant="contained" onClick={() => window.location.reload()}>
            Refresh the page
          </Button>
        ) : (
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              onClick={() => navigate(-1)}
              startIcon={<IconChevronLeft strokeWidth={1.5} />}
            >
              Go back
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate("/")}
              startIcon={<IconHome strokeWidth={1.5} />}
            >
              Get back to home page
            </Button>
          </Stack>
        )}
      </Stack>
    </Container>
  );
};

export default ErrorPage;
